<template>
    <table class="skuTable">
        <thead>
            <th
                v-for="(sp) in specifications"
                :key="sp.name">{{ sp.name }}</th>
            <th
                v-for="col in tableCols"
                :key="col.prop"
                :style="'width:'+skuConfigWidthList[col.config]+'px'">{{ col.label }}</th>
        </thead>
        <tbody>
            <tr
                v-for="(sku,index) in self_skuList"
                :key="sku._skuid + '-' + sku.id"
                :class="{'disabled-row': sku.skuActiveStatus === '停用'}">
                <td
                    v-for="(sp, spi) in specifications"
                    :key="`_sp_${spi}`"
                    :style="'width:'+skuConfigWidthList.color+'px'">
                    {{ sku[`_sp_${spi}`] }}
                </td>
                <td
                    v-for="col in tableCols"
                    :key="col.prop"
                    :style="'width:'+skuConfigWidthList[col.config]+'px'">
                    <AmountDigitText v-if="['levelDistributionPrice', 'salesPrice', 'marketPrice', 'commissionPrice'].includes(col.prop)" :value="sku[col.prop]" :precision="precision"/>
                    <span v-else>{{ sku[col.prop] }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        specifications: {
            type: Array,
            default() {
                return []
            }
        },
        skuList: {
            type: Array,
            default() {
                return []
            }
        },
        skuConfigList:{
            type: Object,
            default() {
                return {}
            }
        },
        skuConfigWidthList:{
            type: Object,
            default() {
                return {}
            }
        },
        precision: Number,
    },
    data() {
        return {
            tableCols: [
                {label: 'SKU编码', prop: 'skuOuterId', config:'skuOuterId'},
                {label: '分销价', prop: 'levelDistributionPrice', config:'distributePrice'},
                {label: '库存', prop: 'stock', config:'stock'},
                {label: '重量（kg）', prop: 'weight', config:'weight'},
                {label: '库存更新时间', prop: 'stockUpdateTime', config:'stockUpdateTime'},
                {label: '销售价', prop: 'salesPrice', config:'salePrice'},
                {label: '市场价', prop: 'marketPrice', config:'marketPrice'},
                {label: '佣金', prop: 'commissionPrice', config:'commissionPrice'},
                {label: '佣金比例', prop: 'commissionScale', config:'commissionScale'},
                {label: '商品新增时间', prop: 'createTime', config:'createdTime'},
                {label: '货位', prop: 'goodsSectionCodes', config:'goodsSectionCodes'},
                {label: '运费', prop: 'freightPrice', config:'freightPrice'},
                {label: '商品状态', prop: 'skuActiveStatus', config:'skuActiveStatus'},
            ]
        }
    },
    computed: {
        self_skuList() {
            let skuList = this.genSkuList();
            
            return skuList.map(sku => {
                let spMap = {}
                sku.skuSpecifications.forEach((skusp, skuspIndex) => {
                    spMap[`_sp_${skuspIndex}`] = skusp.value
                });
                if(!sku.goodsSectionCodes?.length){
                    sku.goodsSectionCodes = ''
                }else{
                    sku.goodsSectionCodes = sku.goodsSectionCodes.join(',')
                }
                let skuActiveStatus = sku.dmjItemDto?.skuActiveStatus || '';

                return {
                    ...sku,
                    ...spMap,
                    skuActiveStatus,
                    levelDistributionPrice: sku.levelDistributionPrice === -1 ? '合作后查看' : sku.levelDistributionPrice
                }
            })
        },
    },
    
    mounted(){
        // 获取供销商还是分销商版本
        let userInfo = this.$store.getters.userInfo;
        this.isSupplier = userInfo.loginIdentity === 1 ? true : false;

        // 供销商端看不到运费，分销商端可以看到
        // if(this.isSupplier){
        //     this.tableCols = this.tableCols.filter(item=>{
        //         return item.config != "freightPrice"
        //     })
        // }
        this.tableCols = this.tableCols.filter(item=>{
            return this.skuConfigList[item.config];
        })
    },
    methods: {
        genSkuList() {
            let _skuList = []

            
            let ori_skuList = this.skuList.map(item => {
                return {
                    ...item,
                    _skuid: item.skuSpecifications.map(({valueKey}) => valueKey).join('-')
                }
            })
            

            function forEach(arr, index = 0, c_arr = []) {
                // 取到最后一层开始作业务逻辑
                if (arr.length === index) {
                    // 若有值为空或未勾选不做任何处理
                    if (c_arr.some(item => (!item.value || !item.checked))) {
                        return;
                    }
                    
                    const _skuid = c_arr.filter(item => !!item.valueKey).map(item => item.valueKey).join('-') // 生成skuid

                     // 新增：找到索引并删除(erp中存在配置允许规格重复，这里根据specifications里面的规格去sku中找的时候存在重复值，所以找到了删除去匹配剩下的可以避免这个问题)
                    const idx = ori_skuList.findIndex(item => _skuid === item._skuid)
                    if (idx !== -1) {
                        _skuList.push(ori_skuList[idx])
                        ori_skuList.splice(idx, 1) // 删除已匹配项
                    }

                    return;
                }
                // 取出一层
                let currItem = arr[index]
                // 此层值循环
                currItem.values.forEach(c => {
                    // 每个值再递归取
                    forEach(arr, index + 1, c_arr.concat(c))
                })
            }

            forEach(this.specifications.filter(item => item.name))
            return _skuList.filter(Boolean)
        }
    }
}
</script>

<style lang="scss" scoped>
.skuTable {
    border: 1px solid #000;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    th, td {
        border: 1px solid #999;
        padding: 5px;
        text-align: center;
    }
    .disabled-row {
        background-color: #f5f5f5;
        color: #999;
    }
}
</style>